import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { ScheduleEmployee } from '../../class/schedule-employee';

@Injectable()
export class ScheduleEmployeeService extends WebService {

    public getScheduleEmployee (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort) + ',-created_at');
        } else {
            params.append('_sort', String('-id'));//params.append('_sort', String('-id,-created_at'));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('employee'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/schedule-employees?${params}`, options);
    }

    public newScheduleEmployee(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/schedule-employees`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateScheduleEmployee(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/schedule-employees/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteScheduleEmployee(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/schedule-employees/${id}`, { headers: this.headers } );
    }

    public infoScheduleEmployee(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        params.append('id', String(id));
        params.append('_sort', String('-created_at'));
        params.append('_with', String('employee'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/schedule-employees/${id}?${params}`,  options );
    }
}




// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/schedule-employee/scheduleEmployee.service.ts